import { render, staticRenderFns } from "./SceneManagement.vue?vue&type=template&id=4dabc651&scoped=true"
import script from "./SceneManagement.vue?vue&type=script&lang=js"
export * from "./SceneManagement.vue?vue&type=script&lang=js"
import style0 from "./SceneManagement.vue?vue&type=style&index=0&id=4dabc651&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dabc651",
  null
  
)

export default component.exports